exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.text[data-v-ae9d4d46]{\r\n  padding:1em;\n}\n.drag-area[data-v-ae9d4d46]{\r\n\r\n  display: block;\r\n  width: 100%;\r\n  background-color:rgba(28, 133, 154, .05);\n}\n.gray[data-v-ae9d4d46]{\r\n   background-color:rgba(28, 133, 154, 1);\n}\n.salmon[data-v-ae9d4d46]{\r\n  background-color:rgba(28, 133, 154, .05);\n}\nbutton[data-v-ae9d4d46]{\r\n  border: none;\r\n  background-color: #1c869a;\r\n  width: 49%;\r\n  margin: 1em auto;\r\n  padding: 1em;\r\n  color: white;\r\n  font-family: 'Noto Sans KR', sans-serif;\r\n  text-transform: uppercase;\n}\n.underline[data-v-ae9d4d46]{\r\n  text-decoration: underline;\n}\r\n", ""]);

// exports
